import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import {
  MAG_HOME_END_POINTS,
  VIDEOMEDIA_END_POINTS,
} from "core/constants/endpoints";
import instance from "core/constants/request";
import { homeVideoForm } from "../../type";

const updateMagHomeVideo = async ({ data }: { data: homeVideoForm }) => {
  // *** Upload Video Thumbnail ***
  let uploadVideoThumbnailPut;
  if (data?.uploadThumbnail?.file) {
    const videoThumbnailData = new FormData();
    videoThumbnailData.append("Id", String(data?.videoMediaId ?? 0));
    videoThumbnailData.append("AltText", data?.altText ?? "");
    videoThumbnailData.append("Width", String(data?.uploadThumbnail?.width));
    videoThumbnailData.append("Height", String(data?.uploadThumbnail?.height));
    videoThumbnailData.append("SizePercentage", "100");
    videoThumbnailData.append("File", data?.uploadThumbnail?.file);

    uploadVideoThumbnailPut = await instance.put<any>(
      VIDEOMEDIA_END_POINTS.add_thumbnail,
      videoThumbnailData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  // *** Update Video ***
  const formData = new FormData();
  formData.append("Id", String(data?.id ?? 0));
  formData.append("VideoMediaId", String(data?.videoMediaId ?? 0));
  formData.append("Priority", String(data?.priority ?? "0"));
  formData.append("AltText", data.altText ?? "");
  formData.append("Name", data.name ?? "");
  formData.append("Url", data.url ?? "");
  formData.append("IsActive", String(data.isActive ?? "false"));
  formData.append("Description", data?.description ?? "");

  const res = await instance.put(MAG_HOME_END_POINTS.update_video, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

export const useUpdateHomeVideo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      MAG_HOME_END_POINTS.update_video,
      MAG_HOME_END_POINTS.videos_list,
    ],
    mutationFn: updateMagHomeVideo,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data.Message || "خطا در ویرایش ویدیو"}`);
    },
    onSuccess: () => {
      toast.success(`ویدیو با موفقیت ویرایش شد`);
      queryClient.invalidateQueries({
        queryKey: [MAG_HOME_END_POINTS.videos_list],
      });
    },
  });
};
